import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@main/view/layout/MainLayout'
import Page404 from '@main/view/layout/Page404'
// import main from '@main/router'

// 重写push
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

var routerChildren = [];

const path = require('path');
const files = require.context('@/modules', true, /router.js$/);
files.keys().forEach(key => {
  path.basename(key, '.vue');
  var routerOther = (files(key).default || files(key));
  routerChildren.push(...routerOther)
})


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: routerChildren,
    },
    {
      path: '/account',
      component: resolve => require(['@/modules/account/Index'], resolve),
      children: [
        {
          path: 'register/:id?',
          component: resolve => require(['@/modules/account/view/Register'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'signup',
          component: resolve => require(['@/modules/account/view/Signup'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'related-register/:id?',
          component: resolve => require(['@/modules/account/view/RelatedRegister'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'set-password',
          component: resolve => require(['@/modules/account/view/SetPassword'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'loginVerify',
          component: resolve => require(['@/modules/account/view/LoginVerify'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'link-failure',
          component: resolve => require(['@/modules/account/view/LinkFailure'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'forget',
          component: resolve => require(['@/modules/account/view/Forget'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'check-is-way',
          component: resolve => require(['@/modules/account/view/CheckIsWay'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'reset-password',
          component: resolve => require(['@/modules/account/view/ResetPassword'], resolve),
          meta: {
            noLogin: true
          }
        }
      ]
    },
    {
      path: '/error',
      component: resolve => require(['@/modules/error/Index'], resolve),
      children: [
        {
          path: 'invalid-link',
          component: resolve => require(['@/modules/error/view/InvalidLink'], resolve),
          meta: {
            noLogin: true
          }
        },
      ]
    },
    {
      path: '/loginss',
      component: resolve => require(['@/modules/loginss/Index'], resolve),
      children: [
        {
          path: 'first-page/:id',
          component: resolve => require(['@/modules/loginss/view/FirstPage'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'new-first-page',
          component: resolve => require(['@/modules/loginss/view/NewFirstPage'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'link-failure',
          component: resolve => require(['@/modules/loginss/view/LinkFailure'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'bind-account',
          component: resolve => require(['@/modules/loginss/view/BindAccount'], resolve),
          meta: {
            noLogin: true
          }
        },
        {
          path: 'bind-success',
          component: resolve => require(['@/modules/loginss/view/BindSuccess'], resolve),
          meta: {
            noLogin: true
          }
        }
      ]
    },
    {
      path: '/certifyRemind',
      component: resolve => require(['@main/view/layout/CertifyRemind'], resolve),
    },
    {
      path: '/subscribe-success',
      component: resolve => require(['@/modules/cashier/view/payment/SubscribeSuccess'], resolve),
    },
    {
      path: '/control/notAllow',
      component: resolve => require(['@main/view/layout/Page401'], resolve),
    },
    {
      path: '*',
      component: Page404
      // component: resolve => require(['@/views/error/NotFound'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js